import React from "react";

const PageWrapperForm = ({
  config,
  children,
  handleOnclick,
  buttonTitle,
  secondaryButtonTitle,
  handleSecondaryOnclick,
}) => {
  return (
    <main>
      <div className="container-fluid">
        {/* Breadcrumb  */}
        <div className="row m-1">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title">{config.title}</h4>
              <ul className="app-line-breadcrumbs mb-3">
                {/* <li>
                  <a className="f-s-14 f-w-500" href="#">
                    <span>
                      <i
                        className={`${
                          config.breadcrumbIcon || "ph-duotone ph-table"
                        } f-s-16`}
                      ></i>{" "}
                      {config.breadcrumbParent || "Reports"}
                    </span>
                  </a>
                </li> */}
                <li className="active">
                  <a className="f-s-14 f-w-500" href="#">
                    {config.title}
                  </a>
                </li>
              </ul>
            </div>

            {secondaryButtonTitle ? (
              <div
                style={{
                  gap: "1ch",
                  display: "flex",
                }}
              >
                <button
                  className="btn btn-light-primary"
                  onClick={handleOnclick}
                  type="button"
                  key={"primary-button"}
                >
                  <i className="iconoir-user me-2"></i>
                  {buttonTitle}
                </button>
                <button
                  className="btn btn-light-primary"
                  onClick={handleSecondaryOnclick}
                  type="button"
                  key={"secondary-button"}
                >
                  <i className="iconoir-user me-2"></i>
                  {secondaryButtonTitle}
                </button>
              </div>
            ) : (
              <button
                className="btn btn-light-primary"
                onClick={handleOnclick}
                type="button"
                key={"primary-button"}
              >
                <i className="iconoir-user me-2"></i>
                {buttonTitle}
              </button>
            )}
          </div>
        </div>

        {/* Table Section */}
        <div className="row advance-table-section">
          <div className="col-12">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default PageWrapperForm;

// import React from 'react';

// const PageWrapper = ({ config, children }) => {
//   return (
//     <main>
//       <div className="container-fluid">
//         {/* Breadcrumb */}
//         <div className="row m-1">
//           <div className="col-12 d-flex justify-content-between align-items-center">
//             <div>
//               <h4 className="main-title">{config.title}</h4>
//               <ul className="app-line-breadcrumbs mb-3">
//                 <li>
//                   <a className="f-s-14 f-w-500" href="#">
//                     <span>
//                       <i className={`${config.breadcrumbIcon || 'ph-duotone ph-table'} f-s-16`}></i> {config.breadcrumbParent || 'Reports'}
//                     </span>
//                   </a>
//                 </li>
//                 <li className="active">
//                   <a className="f-s-14 f-w-500" href="#">{config.title}</a>
//                 </li>
//               </ul>
//             </div>

//             {config.showDateFilter && (
//               <button
//                 aria-controls="offcanvasTops"
//                 className="btn btn-light-primary"
//                 data-bs-target="#offcanvasTops"
//                 data-bs-toggle="offcanvas"
//                 type="button"
//               >
//                 <i className="iconoir-calendar me-2"></i>
//                 Filter
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Table Section */}
//         <div className="row advance-table-section">
//           <div className="col-12">
//             {children}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default PageWrapper;
